// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { FaUserPlus, FaUsers, FaTrash, FaEdit, FaSave } from "react-icons/fa";

// const API_URL = "http://localhost:8080/api/v1/employees";

// function App() {
//   const [employees, setEmployees] = useState([]);
//   const [form, setForm] = useState({
//     firstName: "",
//     lastName: "",
//     emailId: "",
//     department: "",
//     position: "",
//     salary: "",
//     mobileNumber: "",
//   });
//   const [editId, setEditId] = useState(null);

//   // 1. Fetch Data (Interviewer ko batana: "RESTful GET Request")
//   const loadEmployees = () => {
//     axios
//       .get(API_URL)
//       .then((res) => setEmployees(res.data))
//       .catch((err) => console.log(err));
//   };

//   useEffect(() => {
//     loadEmployees();
//   }, []);

//   // 2. Form Handlers
//   const handleInput = (e) =>
//     setForm({ ...form, [e.target.name]: e.target.value });

//   const handleSave = (e) => {
//     e.preventDefault();
//     // Laravel Style logic: editId hai toh PUT, nahi toh POST
//     const apiCall = editId
//       ? axios.put(`${API_URL}/${editId}`, form)
//       : axios.post(API_URL, form);
//     apiCall.then(() => {
//       setForm({
//         firstName: "",
//         lastName: "",
//         emailId: "",
//         department: "",
//         position: "",
//         salary: "",
//         mobileNumber: "",
//       });
//       setEditId(null);
//       loadEmployees();
//     });
//   };

//   const handleDelete = (id) => {
//     if (window.confirm("Delete record?")) {
//       axios.delete(`${API_URL}/${id}`).then(() => loadEmployees());
//     }
//   };

//   return (
//     <div
//       className="container-fluid py-4"
//       style={{ background: "#f4f7f6", minHeight: "100vh" }}
//     >
//       <div className="container">
//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <h2 className="text-dark fw-bold">
//             <FaUsers className="text-primary me-2" /> StaffPro Management
//           </h2>
//           <span className="badge bg-primary px-3 py-2">
//             Laravel API Project
//           </span>
//         </div>

//         <div className="row">
//           {/* FORM SECTION */}
//           <div className="col-lg-4">
//             <div
//               className="card shadow-sm border-0 p-4 mb-4"
//               style={{ borderRadius: "12px" }}
//             >
//               <h5 className="fw-bold mb-3">
//                 {editId ? "Update Employee" : "Register New Staff"}
//               </h5>
//               <form onSubmit={handleSave}>
//                 <input
//                   className="form-control mb-2"
//                   name="firstName"
//                   placeholder="First Name"
//                   value={form.firstName}
//                   onChange={handleInput}
//                   required
//                 />
//                 <input
//                   className="form-control mb-2"
//                   name="lastName"
//                   placeholder="Last Name"
//                   value={form.lastName}
//                   onChange={handleInput}
//                   required
//                 />
//                 <input
//                   className="form-control mb-2"
//                   name="emailId"
//                   type="email"
//                   placeholder="Email"
//                   value={form.emailId}
//                   onChange={handleInput}
//                   required
//                 />
//                 <input
//                   className="form-control mb-2"
//                   name="department"
//                   placeholder="Department"
//                   value={form.department}
//                   onChange={handleInput}
//                   required
//                 />
//                 <input
//                   className="form-control mb-2"
//                   name="position"
//                   placeholder="Position"
//                   value={form.position}
//                   onChange={handleInput}
//                   required
//                 />
//                 <input
//                   className="form-control mb-2"
//                   name="salary"
//                   type="number"
//                   placeholder="Salary (INR)"
//                   value={form.salary}
//                   onChange={handleInput}
//                   required
//                 />
//                 <input
//                   className="form-control mb-3"
//                   name="mobileNumber"
//                   placeholder="Mobile Number"
//                   value={form.mobileNumber}
//                   onChange={handleInput}
//                   required
//                 />
//                 <button
//                   className={`btn w-100 fw-bold ${editId ? "btn-warning" : "btn-primary"}`}
//                 >
//                   <FaSave className="me-2" />{" "}
//                   {editId ? "Update Record" : "Save Employee"}
//                 </button>
//               </form>
//             </div>
//           </div>

//           {/* TABLE SECTION */}
//           <div className="col-lg-8">
//             <div
//               className="card shadow-sm border-0 overflow-hidden"
//               style={{ borderRadius: "12px" }}
//             >
//               <table className="table table-hover align-middle mb-0">
//                 <thead className="table-light">
//                   <tr className="small text-uppercase">
//                     <th className="ps-4">Employee</th>
//                     <th>Role/Dept</th>
//                     <th>Salary</th>
//                     <th className="text-center">Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {employees.map((emp) => (
//                     <tr key={emp.id}>
//                       <td className="ps-4">
//                         <div className="fw-bold">
//                           {emp.firstName} {emp.lastName}
//                         </div>
//                         <div className="small text-muted">
//                           {emp.emailId} | {emp.mobileNumber}
//                         </div>
//                       </td>
//                       <td>
//                         <div className="fw-bold">{emp.position}</div>
//                         <span className="badge bg-light text-primary border">
//                           {emp.department}
//                         </span>
//                       </td>
//                       <td className="text-success fw-bold">₹{emp.salary}</td>
//                       <td className="text-center">
//                         <button
//                           className="btn btn-sm btn-outline-primary me-2 border-0"
//                           onClick={() => {
//                             setEditId(emp.id);
//                             setForm(emp);
//                           }}
//                         >
//                           <FaEdit />
//                         </button>
//                         <button
//                           className="btn btn-sm btn-outline-danger border-0"
//                           onClick={() => handleDelete(emp.id)}
//                         >
//                           <FaTrash />
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default App;
import React, { useState, useEffect } from "react"; // Fix: useState camelCase
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
// Fix: Sare icons aur unke naam professional dashboards ke hisab se update kiye gaye hain.
import {
  FaUserPlus,
  FaUsers,
  FaTrashAlt,
  FaEdit,
  FaSave,
} from "react-icons/fa";

// URL professional standard ke hisab se clean rakha hai.
const API_BASE_URL = "http://localhost:8080/api/v1/employees";

function App() {
  // Fix: useSate se useState tak camelCase (case-sensitive errors prevent karne ke liye)
  const [employees, setEmployees] = useState([]);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    emailId: "",
    department: "",
    position: "",
    salary: "",
    mobileNumber: "",
  });
  const [editId, setEditId] = useState(null);

  // function ka naam loadEmployees jaisa professional rakha hai.
  const loadEmployees = () => {
    // .then() chain is clean for interview explanations.
    axios
      .get(API_BASE_URL)
      .then((res) => {
        setEmployees(res.data);
      })
      .catch((err) => {
        console.error("API call error:", err);
        // Interview mein error handling dikhana important hai.
      });
  };

  useEffect(() => {
    loadEmployees();
  }, []);

  // Form handle logic ko concise (chhota) rakha hai taaki interviewer ko 2 line mein samjha sako.
  const handleInput = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = (e) => {
    e.preventDefault();
    const action = editId
      ? axios.put(`${API_BASE_URL}/${editId}`, form)
      : axios.post(API_BASE_URL, form);
    action.then(() => {
      // Form clear logic after successful save/update.
      setForm({
        firstName: "",
        lastName: "",
        emailId: "",
        department: "",
        position: "",
        salary: "",
        mobileNumber: "",
      });
      setEditId(null);
      loadEmployees();
    });
  };

  const handleDelete = (id) => {
    if (window.confirm("Kyan aap permanent delete karna chahte hain?")) {
      axios.delete(`${API_BASE_URL}/${id}`).then(() => {
        loadEmployees();
      });
    }
  };

  return (
    <div
      className="container-fluid py-4 bg-light"
      style={{ minHeight: "100vh" }}
    >
      <div className="container">
        {/* Header updated for a better professional dashboard feel. */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="text-dark fw-bold">
            <FaUsers className="text-primary me-2" /> Staff Enterprise Dashboard
          </h2>
          <span className="badge bg-primary text-uppercase px-3 py-2">
            Restful API Integrated
          </span>
        </div>

        <div className="row">
          {/* FORM SECTION: Left side */}
          <div className="col-lg-4">
            <div
              className="card shadow-sm border-0 p-4 mb-4"
              style={{ borderRadius: "12px" }}
            >
              <h5 className="fw-bold mb-3">
                {editId ? "Update Employee" : "Register New Staff"}
              </h5>
              <form onSubmit={handleSave}>
                <input
                  className="form-control mb-2"
                  name="firstName"
                  placeholder="First Name"
                  value={form.firstName}
                  onChange={handleInput}
                  required
                />
                <input
                  className="form-control mb-2"
                  name="lastName"
                  placeholder="Last Name"
                  value={form.lastName}
                  onChange={handleInput}
                  required
                />
                <input
                  className="form-control mb-2"
                  name="emailId"
                  type="email"
                  placeholder="Email (Primary Key)"
                  value={form.emailId}
                  onChange={handleInput}
                  required
                />
                <input
                  className="form-control mb-2"
                  name="department"
                  placeholder="Department (e.g., IT, HR)"
                  value={form.department}
                  onChange={handleInput}
                  required
                />
                <input
                  className="form-control mb-2"
                  name="position"
                  placeholder="Position (e.g., Developer)"
                  value={form.position}
                  onChange={handleInput}
                  required
                />
                <input
                  className="form-control mb-2"
                  name="salary"
                  type="number"
                  placeholder="Salary (INR)"
                  value={form.salary}
                  onChange={handleInput}
                  required
                />
                <input
                  className="form-control mb-3"
                  name="mobileNumber"
                  placeholder="Mobile Number"
                  value={form.mobileNumber}
                  onChange={handleInput}
                  required
                />
                <button
                  className={`btn w-100 fw-bold d-flex align-items-center justify-content-center ${editId ? "btn-warning" : "btn-primary"}`}
                >
                  <FaSave className="me-2" />{" "}
                  {editId ? "Update Record" : "Save to Database"}
                </button>
              </form>
            </div>
          </div>

          {/* TABLE SECTION: Right side */}
          <div className="col-lg-8">
            <div
              className="card shadow-sm border-0 overflow-hidden"
              style={{ borderRadius: "12px" }}
            >
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light">
                  <tr className="small text-uppercase">
                    <th className="ps-4">Employee Details</th>
                    <th>Role/Dept</th>
                    <th>Salary</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {employees.map((emp) => (
                    <tr key={emp.id}>
                      <td className="ps-4">
                        <div className="fw-bold">
                          {emp.firstName} {emp.lastName}
                        </div>
                        <div className="small text-muted">
                          {emp.emailId} | {emp.mobileNumber}
                        </div>
                      </td>
                      <td>
                        <div className="fw-bold">{emp.position}</div>
                        <span className="badge bg-light text-primary border">
                          {emp.department}
                        </span>
                      </td>
                      <td className="text-success fw-bold">₹{emp.salary}</td>
                      <td className="text-center">
                        <button
                          className="btn btn-sm btn-outline-primary me-2 border-0"
                          onClick={() => {
                            setEditId(emp.id);
                            setForm(emp);
                          }}
                        >
                          <FaEdit />
                        </button>
                        <button
                          className="btn btn-sm btn-outline-danger border-0"
                          onClick={() => handleDelete(emp.id)}
                        >
                          <FaTrashAlt />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
